import { Component, Element, Host, State, h } from '@stencil/core';
import { generateId } from '../../utils/functions';

/**
 * Tabs consolidate groups of content into their own sections, often simplifying a user interface and making data items easier to locate.
 */
@Component({
  tag: 'som-tabs',
  styleUrl: 'som-tabs.scss',
})
export class SomTabs {
  @Element() el: HTMLElement;

  @State() tabsId: string = generateId('som-tabs-')

  tabs;
  panels;
  tabGroup;
  panelGroup;

  componentDidLoad() {
    this.tabs = [].slice.call(document.querySelectorAll(`#${this.tabsId} > som-tab-group > som-tab`));
    this.panels = [].slice.call(document.querySelectorAll(`#${this.tabsId} > som-tab-panel-group > som-tab-panel`));
    this.tabGroup = document.querySelector(`#${this.tabsId} > som-tab-group`);
    this.panelGroup = document.querySelector(`#${this.tabsId} > som-tab-panel-group`);
    const panelColor = this.tabGroup.getAttribute('color');
    let activeFound = false;

    // Are there any panels?
    const panelsExist = this.panels.length > 0 ? true : false;

    // set panel color
    if (panelsExist) this.panelGroup.classList.add(panelColor);

    // Set aria controls on tab and panel
    // Make sure the active tab and panel are shown or default to first if not set
    this.tabs.forEach((tab, idx) => {
      if (panelsExist) {
        tab.setAttribute('aria-controls', this.panels[idx].getAttribute('id'));
        this.panels[idx].setAttribute('aria-labelledby', tab.getAttribute('id'));
      }

      tab.classList.add(`tab-panel-${panelColor}`);

      // Is the tab set to active?  If so, show the tab and panel
      if (tab.hasAttribute('active')) {
        const _active = tab.getAttribute('active');
        if (_active || _active === '') {
          this.tabGroup.showTab(idx);
          if (panelsExist) this.panelGroup.showTabPanel(idx);
          activeFound = true;
        }
      }
    });

    // The active prop wasn't set on a tab, default to the first tab
    if (!activeFound) {
      this.tabs[0].setAttribute('active', 'true');
      if (panelsExist) this.panelGroup.showTabPanel(0);
      this.tabGroup.showTab(0);
    }

    // Set up listener for when an individual tab is clicked
    this.tabGroup.addEventListener('tabClick', (e) => {
      // Update active tab and panel
      const _idx = this.tabs.findIndex(tab => tab.tabId === e.detail.tabId);
      this.tabGroup.showTab(_idx);
      if (panelsExist) this.panelGroup.showTabPanel(_idx);
    })
  }

  render() {
    return (
      <Host id={this.tabsId}>
        <slot></slot>
      </Host>
    );
  }
}